module.exports = __webpack_public_path__ + "fonts/d49c707d7956a039fa58863de37010ef.svg";